import React from "react";
import {LabeledValue} from "antd/lib/select";
import DelegatedInsurerMultiSelect from "../../select/MultiSelect/DelegatedInsurerMultiSelect";
import {FilterDropdownProps} from "antd/lib/table/interface";
import FilterContainer from "./FilterContainer";
import {DELAY_TIMER_SEARCH_FILTER, endAndStartTimerFilter} from "./columnsUtils";
import BrokerBranchMultiSelect from "../../select/MultiSelect/BrokerBranchMultiSelect";

export default function BrokerBranchFilter(props: FilterDropdownProps) {

    return <FilterContainer {...props}>
        <BrokerBranchMultiSelect
            style={{width: '20rem'}}
            onChange={(values: LabeledValue[]) => {
                // @ts-ignore
                props.setSelectedKeys(values.reverse().map(el => ({label: el.label, value: el.value})))
                endAndStartTimerFilter(props.confirm, DELAY_TIMER_SEARCH_FILTER)
            }}
            value={props.selectedKeys}
        />
    </FilterContainer>

}